import type { InAppAnnouncementDestination } from "schemas/inAppAnnouncement";

import { getInAppAnnouncementHref } from "schemas/inAppAnnouncement";

// Theme Builder has no app tabs, so an app destination goes through the link that finds the user's own Agent project.
export function useOpenInAppAnnouncementDestination() {
  return (destination: InAppAnnouncementDestination) => {
    const href = getInAppAnnouncementHref(destination);
    const local = href.replace("https://dashboard.replo.app", "");
    window.open(
      destination.kind === "app" ? local : href,
      "_blank",
      "noopener,noreferrer",
    );
  };
}
